function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVersions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Versions",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.625-10.5a1.751 1.751 0 0 1 1.75-1.75h7a1.751 1.751 0 0 1 1.75 1.75V0a1.752 1.752 0 0 1-1.75 1.75h-7A1.752 1.752 0 0 1-2.625 0zm1.313 0V0a.439.439 0 0 0 .437.438h7A.439.439 0 0 0 6.563 0v-10.5a.438.438 0 0 0-.437-.437h-7a.438.438 0 0 0-.438.437zm-3.937.219a.656.656 0 0 1 .656-.656.656.656 0 0 1 .656.656V-.219a.655.655 0 0 1-.656.656.655.655 0 0 1-.657-.656zm-2.626 1.312a.656.656 0 0 1 .656-.656.656.656 0 0 1 .656.656v7.438a.656.656 0 0 1-.656.656.656.656 0 0 1-.656-.656z",
    transform: "translate(12 17)",
    style: {
      fill: "#3a4043"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVersions);
export default __webpack_public_path__ + "static/media/IconVersions.e695e28c721ec5cbe405a5bfcba17617.svg";
export { ForwardRef as ReactComponent };